export enum StorageType {
  SESSION = 'SESSION',
  LOCAL = 'LOCAL',
}
